import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "readonly"]

import { ref, computed, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextareaComponent',
  props: {
    placeHolder: {},
    errorMessage: {},
    modelValue: {},
    shouldResize: { type: Boolean },
    readOnly: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const id = Math.random().toString(36).slice(2);
const textAreaComponent = ref<HTMLElement | null>(null);

const val = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val);
  },
});

onMounted(() => {
  resize();
});

function resize(): void {
  if (props.shouldResize) {
    if (textAreaComponent.value) {
      textAreaComponent.value.style.height = '102px';
      textAreaComponent.value.style.height = textAreaComponent.value.scrollHeight + 2 + 'px';
      if (textAreaComponent.value.scrollHeight > textAreaComponent.value.offsetHeight) {
        textAreaComponent.value.style.height = textAreaComponent.value.scrollHeight + 2 + 'px';
      }
      if (props.modelValue === '') {
        textAreaComponent.value.style.height = '102px';
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["textarea-component", {
      'resize-textarea': _ctx.shouldResize,
    }])
  }, [
    (_ctx.placeHolder || _ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: 'textarea' + _unref(id)
        }, [
          _createTextVNode(_toDisplayString(_ctx.placeHolder) + " ", 1),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("- " + _toDisplayString(_ctx.errorMessage), 1)
              ], 64))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("textarea", {
      placeholder: " ",
      id: 'textarea' + _unref(id),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((val).value = $event)),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (resize())),
      ref_key: "textAreaComponent",
      ref: textAreaComponent,
      readonly: _ctx.readOnly
    }, null, 40, _hoisted_2), [
      [_vModelText, val.value]
    ])
  ], 2))
}
}

})